import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "recycler-before",
  ref: "recyclerBefore"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_TopMatter = _resolveComponent("TopMatter")!
  const _component_EmptyContent = _resolveComponent("EmptyContent")!
  const _component_TimelineTopOverlay = _resolveComponent("TimelineTopOverlay")!
  const _component_DynamicTopMatter = _resolveComponent("DynamicTopMatter")!
  const _component_RowHead = _resolveComponent("RowHead")!
  const _component_Photo = _resolveComponent("Photo")!
  const _component_RecycleScroller = _resolveComponent("RecycleScroller")!
  const _component_ScrollerManager = _resolveComponent("ScrollerManager")!
  const _component_SelectionManager = _resolveComponent("SelectionManager")!
  const _component_SwipeRefresh = _resolveComponent("SwipeRefresh")!

  return (_openBlock(), _createBlock(_component_SwipeRefresh, {
    class: "memories-timeline container no-user-select",
    ref: "container",
    match: ".recycler",
    refresh: _ctx.softRefreshSync,
    allowSwipe: _ctx.allowSwipe,
    state: _ctx.state
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_XLoadingIcon, {
            key: 0,
            class: "loading-icon centered"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_TopMatter, { ref: "topmatter" }, null, 512),
      (_ctx.showEmpty)
        ? (_openBlock(), _createBlock(_component_EmptyContent, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_TimelineTopOverlay, {
        ref: "topOverlay",
        heads: _ctx.heads,
        container: _ctx.refs().container?.$el,
        recycler: _ctx.refs().recycler?.$el
      }, null, 8, ["heads", "container", "recycler"]),
      _createVNode(_component_RecycleScroller, {
        ref: "recycler",
        class: _normalizeClass(["recycler hide-scrollbar", { empty: _ctx.empty }]),
        tabindex: "1",
        items: _ctx.list,
        "emit-update": true,
        buffer: 800,
        skipHover: true,
        "key-field": "id",
        "size-field": "size",
        "type-field": "type",
        updateInterval: 100,
        onUpdate: _ctx.scrollChangeRecycler
      }, {
        before: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mobile-header-top-gap" }, null, -1)),
            _createVNode(_component_DynamicTopMatter, {
              ref: "dtm",
              onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refs().scrollerManager.adjust()))
            }, null, 512)
          ], 512)
        ]),
        default: _withCtx(({ item, index }) => [
          (item.type === 0)
            ? (_openBlock(), _createBlock(_component_RowHead, {
                key: 0,
                item: item,
                onClick: ($event: any) => (_ctx.refs().selectionManager.selectHead(item))
              }, null, 8, ["item", "onClick"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.photos ?? [], (photo) => {
                return (_openBlock(), _createBlock(_component_Photo, {
                  class: "photo top-left",
                  key: photo.key,
                  style: _normalizeStyle({
              height: `${photo.dispH}px`,
              width: `${photo.dispW}px`,
              transform: `translate(${photo.dispX}px, ${photo.dispY}px)`,
            }),
                  data: photo,
                  day: item.day,
                  onSelect: ($event: any) => (_ctx.refs().selectionManager.clickSelectionIcon(photo, $event, index)),
                  onPointerdown: ($event: any) => (_ctx.refs().selectionManager.clickPhoto(photo, $event, index)),
                  onTouchstart: ($event: any) => (_ctx.refs().selectionManager.touchstartPhoto(photo, $event, index)),
                  onTouchend: ($event: any) => (_ctx.refs().selectionManager.touchendPhoto(photo, $event, index)),
                  onTouchmove: ($event: any) => (_ctx.refs().selectionManager.touchmovePhoto(photo, $event, index))
                }, null, 8, ["style", "data", "day", "onSelect", "onPointerdown", "onTouchstart", "onTouchend", "onTouchmove"]))
              }), 128))
        ]),
        _: 1
      }, 8, ["class", "items", "onUpdate"]),
      _withDirectives(_createVNode(_component_ScrollerManager, {
        ref: "scrollerManager",
        rows: _ctx.list,
        fullHeight: _ctx.scrollerHeight,
        recycler: _ctx.refs().recycler,
        recyclerBefore: _ctx.refs().recyclerBefore,
        onInteractend: _ctx.loadScrollView,
        onScroll: _cache[1] || (_cache[1] = ($event: any) => {
        _ctx.currentScroll = $event.current;
        _ctx.refs().topOverlay?.refresh();
      })
      }, null, 8, ["rows", "fullHeight", "recycler", "recyclerBefore", "onInteractend"]), [
        [_vShow, !_ctx.showEmpty]
      ]),
      _createVNode(_component_SelectionManager, {
        ref: "selectionManager",
        heads: _ctx.heads,
        rows: _ctx.list,
        isreverse: _ctx.isMonthView,
        recycler: _ctx.refs().recycler?.$el,
        scrollerManager: _ctx.refs().scrollerManager,
        onUpdateLoading: _ctx.updateLoading
      }, null, 8, ["heads", "rows", "isreverse", "recycler", "scrollerManager", "onUpdateLoading"])
    ]),
    _: 1
  }, 8, ["refresh", "allowSwipe", "state"]))
}